module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/big_image@1x.11ddb5c.jpg";